module.exports = __webpack_public_path__ + "img/zdybd_1.85fb5e84.png";